require('../bootstrap');
import * as func from '../functions';

$(document).ready(function() {
    const carsList = {
        isLoading: false,
        isLoadingCount: false,
        init() {
            $(document).on('click', '.fcolor', this, this.selectColor);
            $(document).on('change', '#fbrand', this, this.selectManufacturer);
            $(document).on('change', '.filter-input', this, this.filtersChanged);
            $(document).on('click', '.show-cars-btn', this, this.search);
        },
        selectColor(event) {
            const _this = event.data;

			let id = $(this).data('id');

			let index = filtersCarColours.indexOf(id);
			if (index == -1) {
				filtersCarColours.push(id);
				$(this).addClass('active');
			} else {
				filtersCarColours.splice(index, 1);
				$(this).removeClass('active');
			}

			_this.countCars(event);
		},
		selectManufacturer(event) {
			const _this = event.data;

			$('#fmodel').find('option').slice(2).remove();

			if ($('#fbrand option:selected').val() == '') {
				$('#fmodel').prop("disabled", true);
				return;
			}

			$('#fmodel').prop("disabled", false);
			var models = $('#fbrand option:selected').data('models');

			for(var i in models) {
				$('#fmodel').append('<option value="'+models[i].id+'">'+models[i].name+'</option>');
			}

			_this.countCars(event);
		},
		filtersChanged(event) {
			const _this = event.data;

			_this.countCars(event);
		},
		search(event) {
			const _this = event.data;

			var url = '';

			if (filtersCarColours.length > 0) {
				url += (url != '' ? '&c=' + filtersCarColours.join(',') : '?c=' + filtersCarColours.join(','));
			}
			if ($('#fbrand option:selected').val() != '') {
				url += (url != '' ? '&b=' + $('#fbrand option:selected').val() : '?b=' + $('#fbrand option:selected').val());
			}
			if ($('#fmodel option:selected').val() != '') {
				url += (url != '' ? '&m=' + $('#fmodel option:selected').val() : '?m=' + $('#fmodel option:selected').val());
			}
			if ($('#fbody-type option:selected').val() != '') {
				url += (url != '' ? '&bt=' + $('#fbody-type option:selected').val() : '?bt=' + $('#fbody-type option:selected').val());
			}
			if ($('#ftransmission option:selected').val() != '') {
				url += (url != '' ? '&t=' + $('#ftransmission option:selected').val() : '?t=' + $('#ftransmission option:selected').val());
			}
			if ($('#fwheel_drive option:selected').val() != '') {
				url += (url != '' ? '&wd=' + $('#fwheel_drive option:selected').val() : '?wd=' + $('#fwheel_drive option:selected').val());
			}
			if ($('#ffuel option:selected').val() != '') {
				url += (url != '' ? '&f=' + $('#ffuel option:selected').val() : '?f=' + $('#ffuel option:selected').val());
			}
			if ($('#ffkm option:selected').val() != '') {
				url += (url != '' ? '&fkm=' + $('#ffkm option:selected').val() : '?fkm=' + $('#ffkm option:selected').val());
			}
			if ($('#ftkm option:selected').val() != '') {
				url += (url != '' ? '&tkm=' + $('#ftkm option:selected').val() : '?tkm=' + $('#ftkm option:selected').val());
			}
			if ($('#ffprice option:selected').val() != '') {
				url += (url != '' ? '&fp=' + $('#ffprice option:selected').val() : '?fp=' + $('#ffprice option:selected').val());
			}
			if ($('#ftprice option:selected').val() != '') {
				url += (url != '' ? '&tp=' + $('#ftprice option:selected').val() : '?tp=' + $('#ftprice option:selected').val());
			}
			if ($('#ffyear option:selected').val() != '') {
				url += (url != '' ? '&fy=' + $('#ffyear option:selected').val() : '?fy=' + $('#ffyear option:selected').val());
			}
			if ($('#ftyear option:selected').val() != '') {
				url += (url != '' ? '&ty=' + $('#ftyear option:selected').val() : '?ty=' + $('#ftyear option:selected').val());
			}
			if ($('#ffcc option:selected').val() != '') {
				url += (url != '' ? '&fcc=' + $('#ffcc option:selected').val() : '?fcc=' + $('#ffcc option:selected').val());
			}
			if ($('#ftcc option:selected').val() != '') {
				url += (url != '' ? '&tcc=' + $('#ftcc option:selected').val() : '?tcc=' + $('#ftcc option:selected').val());
			}
			if ($('#ffpw option:selected').val() != '') {
				url += (url != '' ? '&fpw=' + $('#ffpw option:selected').val() : '?fpw=' + $('#ffpw option:selected').val());
			}
			if ($('#ftpw option:selected').val() != '') {
				url += (url != '' ? '&tpw=' + $('#ftpw option:selected').val() : '?tpw=' + $('#ftpw option:selected').val());
			}
			if ($('#immediate_delivery').is(':checked')) {
				url += (url != '' ? '&imd=1' : '?imd=1');
			}
			if ($('#external_stock').is(':checked')) {
				url += (url != '' ? '&es=1' : '?es=1');
			}
			if ($('#available_for_test_drive').is(':checked')) {
				url += (url != '' ? '&atd=1' : '?atd=1');
			}

			window.location = carListPage + url;
		},
		countCars(event) {
			const _this = event.data;

			//Loading...
            _this.isLoadingCount = true;

            var values = '_token=' + $("meta[name=csrf-token]").attr('content');

			if (filtersCarColours.length > 0) {
				values += '&colours=' + filtersCarColours.join(',');
			}
			if ($('#fbrand option:selected').val() != '') {
				values += '&manufacturer=' + $('#fbrand option:selected').val();
			}
			if ($('#fmodel option:selected').val() != '') {
				values += '&models=' + $('#fmodel option:selected').val();
			}
			if ($('#fbody-type option:selected').val() != '') {
				values += '&bodies=' + $('#fbody-type option:selected').val();
			}
			if ($('#ftransmission option:selected').val() != '') {
				values += '&transmission=' + $('#ftransmission option:selected').val();
			}
			if ($('#fwheel_drive option:selected').val() != '') {
				values += '&wheel_drive=' + $('#fwheel_drive option:selected').val();
			}
			if ($('#ffuel option:selected').val() != '') {
				values += '&fuel_type=' + $('#ffuel option:selected').val();
			}
			if ($('#ffkm option:selected').val() != '') {
				values += '&fkm=' + $('#ffkm option:selected').val();
			}
			if ($('#ftkm option:selected').val() != '') {
				values += '&tkm=' + $('#ftkm option:selected').val();
			}
			if ($('#ffprice option:selected').val() != '') {
				values += '&fprice=' + $('#ffprice option:selected').val();
			}
			if ($('#ftprice option:selected').val() != '') {
				values += '&tprice=' + $('#ftprice option:selected').val();
			}
			if ($('#ffyear option:selected').val() != '') {
				values += '&fyear=' + $('#ffyear option:selected').val();
			}
			if ($('#ftyear option:selected').val() != '') {
				values += '&tyear=' + $('#ftyear option:selected').val();
			}
			if ($('#ffcc option:selected').val() != '') {
				values += '&fcc=' + $('#ffcc option:selected').val();
			}
			if ($('#ftcc option:selected').val() != '') {
				values += '&tcc=' + $('#ftcc option:selected').val();
			}
			if ($('#ffpw option:selected').val() != '') {
				values += '&fpw=' + $('#ffpw option:selected').val();
			}
			if ($('#ftpw option:selected').val() != '') {
				values += '&tpw=' + $('#ftpw option:selected').val();
			}
			if ($('#immediate_delivery').is(':checked')) {
				values += '&imd=1';
			}
			if ($('#external_stock').is(':checked')) {
				values += '&es=1';
			}
			if ($('#available_for_test_drive').is(':checked')) {
				values += '&atd=1';
			}

            $.ajax({
                type: "POST",
                url: `${baseURL}/vehicles/count`,
                data: values,
                beforeSend: function() {
                    _this.isLoadingCount = true;
                },
                complete: function() {
                    _this.isLoadingCount = false;
                },
                success: function(response, xhr) {
                    _this.isLoadingCount = false;

                    $('.cars-counter').text(response.count_label);
                },
                error(error) {
                    _this.isLoadingCount = false;
                },
            });
		}
    };

    if ($('.cars-list-page').length) {
        carsList.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/cars-list.js